// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-container[data-v-5360428f] {\n  width: 100%;\n}\n.list-container .toolbar[data-v-5360428f] {\n  width: 100%;\n  height: 50px;\n}", ""]);
// Exports
module.exports = exports;
